// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --font-heading: "Montserrat", system-ui, sans-serif;
  --font-body: "Inter", system-ui, sans-serif;

  --radius-xl: 18px;
  --radius-lg: 14px;
  --radius-md: 10px;
  --shadow-lg: 0 10px 30px rgba(0, 0, 0, 0.15);
  --shadow-md: 0 6px 18px rgba(0, 0, 0, 0.1);
}

.eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 12px;
}
.eyebrow .dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
}
#title {
  font-family: var(--font-heading);
  font-size: clamp(30px, 4.4vw, 48px);
  line-height: 1.1;
  margin: 14px 0 8px 0;
}
.lead {
  color: #444;
  font-size: 18px;
}

.ticker {
  margin-top: 16px;
  overflow: hidden;
}
.ticker-track {
  display: flex;
  gap: 24px;
  padding: 10px 0;
  white-space: nowrap;
  animation: slide 28s linear infinite;
}
.tick {
  font-size: 14px;
}
.tick strong {
}
@keyframes slide {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

.hero {
  position: relative;
  margin-top: 14px;
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
  overflow: hidden;
}

.hero-inner {
  padding: 48px 28px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 18px;
  margin-top: 22px;
}

.card {
  grid-column: span 12;
  border-radius: var(--radius-lg);
  padding: 18px;
  box-shadow: 0 6px 18px rgba(2, 16, 32, 0.15);
  border: 1px solid rgba(10, 26, 43, 0.06);
}

.span-12 {
  grid-column: span 12;
}

@media (min-width: 720px) {
  .span-6 {
    grid-column: span 6;
  }
  .span-4 {
    grid-column: span 4;
  }
}
.card h3 {
  font-family: var(--font-heading);
  font-size: 18px;
  margin: 0 0 8px 0;
}
`, "",{"version":3,"sources":["webpack://./src/datalign-module-template/components/info-sections/index.css"],"names":[],"mappings":"AAAA;EACE,mDAAmD;EACnD,2CAA2C;;EAE3C,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,oCAAoC;AACtC;AACA;EACE,eAAe;AACjB;AACA;AACA;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,aAAa;EACb,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[":root {\n  --font-heading: \"Montserrat\", system-ui, sans-serif;\n  --font-body: \"Inter\", system-ui, sans-serif;\n\n  --radius-xl: 18px;\n  --radius-lg: 14px;\n  --radius-md: 10px;\n  --shadow-lg: 0 10px 30px rgba(0, 0, 0, 0.15);\n  --shadow-md: 0 6px 18px rgba(0, 0, 0, 0.1);\n}\n\n.eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 999px;\n  font-weight: 600;\n  font-size: 12px;\n}\n.eyebrow .dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n}\n#title {\n  font-family: var(--font-heading);\n  font-size: clamp(30px, 4.4vw, 48px);\n  line-height: 1.1;\n  margin: 14px 0 8px 0;\n}\n.lead {\n  color: #444;\n  font-size: 18px;\n}\n\n.ticker {\n  margin-top: 16px;\n  overflow: hidden;\n}\n.ticker-track {\n  display: flex;\n  gap: 24px;\n  padding: 10px 0;\n  white-space: nowrap;\n  animation: slide 28s linear infinite;\n}\n.tick {\n  font-size: 14px;\n}\n.tick strong {\n}\n@keyframes slide {\n  from {\n    transform: translateX(0);\n  }\n  to {\n    transform: translateX(-50%);\n  }\n}\n\n.hero {\n  position: relative;\n  margin-top: 14px;\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-lg);\n  overflow: hidden;\n}\n\n.hero-inner {\n  padding: 48px 28px;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  gap: 18px;\n  margin-top: 22px;\n}\n\n.card {\n  grid-column: span 12;\n  border-radius: var(--radius-lg);\n  padding: 18px;\n  box-shadow: 0 6px 18px rgba(2, 16, 32, 0.15);\n  border: 1px solid rgba(10, 26, 43, 0.06);\n}\n\n.span-12 {\n  grid-column: span 12;\n}\n\n@media (min-width: 720px) {\n  .span-6 {\n    grid-column: span 6;\n  }\n  .span-4 {\n    grid-column: span 4;\n  }\n}\n.card h3 {\n  font-family: var(--font-heading);\n  font-size: 18px;\n  margin: 0 0 8px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
